export const HERO_MAP_DEFAULT_ZOOM = 12;
export const FISHINGWATER_MIN_ZOOM = 7;
export const FISHINGWATER_MAX_ZOOM = 13;
export const FISHINGWATER_TOO_ZOOMED_IN = 12;
